export default {
  layout: "Indelingen",
  invoiceDefaultSettings: "Algemeen",
  invoiceNumberSettings: "Factuurnummer",
  invoicePrintTemplateSettings: "Facturatie print template",
}
